import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";
import "../date.js";
import { German as LocaleDE } from "flatpickr/dist/l10n/de.js"
import { French as LocaleFR } from "flatpickr/dist/l10n/fr.js"
import { Italian as LocaleIT } from "flatpickr/dist/l10n/it.js"
import { english as LocaleEN } from "flatpickr/dist/l10n/default.js"

// Connects to data-controller="login"
export default class extends Controller {
  static targets = ["form", "birthdayDate","companyName","lastName","firstName","birthdateContainer","firstNameInput"]

  connect() {

    let localeToUse = LocaleEN;

    if (document.body.attributes["locale"].value == "de") {
      localeToUse = LocaleDE
    }
    else if (document.body.attributes["locale"].value == "fr") {
      localeToUse = LocaleFR
    }
    else if (document.body.attributes["locale"].value == "it") {
      localeToUse = LocaleIT
    }

    this.fpBirthday = flatpickr("#dateOfBirthWrapper", {
      dateFormat: "d.m.Y",
      weekNumbers: "true",
      wrap: true,
      locale: localeToUse,
      altInput: true,
      allowInput: true,
      altFormat: "d.m.Y",
      onOpen: function (selectDates, dateStr, instance) {
        instance._input.readOnly = true
      },
      onClose: function (selectDates, dateStr, instance) {
        instance._input.readOnly = false
        instance._input.blur()
      }
    });

  }

  async clickedJUR(event){
    this.birthdateContainerTarget.style.dipslay = "none";
    this.birthdateContainerTarget.disabled = true;
    this.firstNameTarget.style.display = "none";
    this.firstNameInputTarget.disabled = true;
    this.lastNameTarget.style.display = "none";
    this.companyNameTarget.style.display = "inline-block";
    this.birthdayDateTarget.disabled = true
    this.lastNameTarget.required = false
    this.firstNameTarget.required = false
  }

  async clickedNAT(event){
    this.birthdateContainerTarget.style.dipslay = "inline-block";
    this.birthdateContainerTarget.disabled = false;
    this.firstNameTarget.style.display = "inline-block";
    this.firstNameInputTarget.disabled = false;
    this.lastNameTarget.style.display = "inline-block";
    this.birthdayDateTarget.disabled = false
    this.companyNameTarget.style.display = "none";
  }

  async clearFields(event){
    event.preventDefault();
    for (i=0; i<this.formTarget.elements.length; i++){
      this.formTarget.elements[i].value = ""
    }
  }

  async clickedSubmit(event) {
    event.preventDefault();

    if (!this.formTarget.checkValidity()) {
      this.formTarget.classList.add("was-validated")
    } else {
      this.formTarget.submit()
    }
  }
}